
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Custom404 from "../components/ReuseableCompos/Custom404";
const Custom404Page = () => {
    return <Custom404 />;
};
export default Custom404Page;

    async function __Next_Translate__getStaticProps__1a13f66bdb3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bdb3__ as getStaticProps }
  